import { FormikHelpers } from 'formik'

import { handleConstraintViolationListError } from '../lib/helpers/helperFunctions'
import errorTypeService from '../lib/services/errorTypeService'
import { useShowGenericServerError } from './useShowGenericServerError'

export function useHandleApiError() {
  const showGenericServerError = useShowGenericServerError()

  function handleApiError({
    error,
    formikHelpers,
  }: {
    error: unknown

    // This is a rare case where it's ok to use `any` but in general we should
    // avoid it
    formikHelpers: FormikHelpers<any> // eslint-disable-line @typescript-eslint/no-explicit-any
  }) {
    if (errorTypeService.isConstraintViolationListError(error)) {
      handleConstraintViolationListError({ error, formikHelpers })
      return
    }

    showGenericServerError()
  }

  return { handleApiError }
}
